export const defaultTripTypes = [
  {
    value: 'return',
    label: 'Return',
  },
  {
    value: 'oneWay',
    label: 'Single',
  },
]

export const defaultTabs = ['ferry', 'stay', 'attractions']

export const passengerTypes = [
  {
    code: 'adult',
    type: 'A',
    description: 'Adults (20-59 yrs)',
    displayOrder: 1,
    enabled: true,
    display: true,
  },
  {
    code: 'child',
    type: 'C',
    description: 'Children (5-15 yrs)',
    displayOrder: 3,
    enabled: true,
    display: true,
  },
  {
    code: 'youth',
    type: 'S',
    description: 'Youth (16-19 yrs)',
    displayOrder: 2,
    enabled: true,
    display: true,
  },
  {
    code: 'infant',
    type: 'I',
    description: 'Infants (0-4 yrs)',
    displayOrder: 4,
    enabled: true,
    display: true,
  },
  {
    code: 'senior',
    type: 'Z',
    description: 'Seniors (60+ yrs)',
    displayOrder: 2,
    enabled: true,
    display: true,
  },
]

export const defaultFerryOptions = [
  {
    value: 'rf',
    label: 'Vehicle / Passenger Ferry',
  },
  {
    value: 'rj',
    label: 'Red Jet Passenger Only',
  },
]

export const defaultRoutes = [
  {
    value: 'SOEC',
    label: 'Southampton to East Cowes',
    ferryId: 'rf',
  },
  {
    value: 'ECSO',
    label: 'East Cowes to Southampton',
    ferryId: 'rf',
  },
  {
    value: 'WCSO',
    label: 'West Cowes to Southampton',
    ferryId: 'rj',
  },
  {
    value: 'SOWC',
    label: 'Southampton to West Cowes',
    ferryId: 'rj',
  },
]
